<template>
  <div class="plan-card">
    <span class="h6">Business plan</span>
    <h2 class="h2">
      <div v-if="businessCounter <= 1 || !businessCounter" class="current-price">
        ${{ "29.00" }}
      </div>
      <div v-else-if="businessCounter > 30" class="current-price">
        ${{ counter('increase') }}
      </div>
      <div v-else class="current-price">
        ${{ ((getBusinessPricePerUser() / businessCounter) / 12).toFixed(2) }}
      </div>
      <span class="body-1">month/user</span>
    </h2>
    <div class="users-holder">
      <div class="users">
        <span class="caption">
          Billed annually
        </span>
        <span class="note">2 users minimum</span>
      </div>
      <span class="users-count">
        <IconMinus :class="{ disabled: businessCounter <= 2 }" class="decrease" @click="counter('decrease')" />
        <input
          v-model="businessCounter"
          type="text"
          class="counter"
          @keydown="setQuantity"
          @keyup="setQuantityInState"
        >
        <IconPlus :class="{ disabled: businessCounter >= 30 }" class="increase" @click="counter('increase')" />
        <div v-if="show" class="bubble" @click="show = !show">
          If you want to purchase more than 30 subscriptions, please <span class="link-accent" @click="$store.dispatch('modals/open', { name: 'contact-sales' })">contact sales</span>
        </div>
      </span>
    </div>
    <div class="buttons">
      <nuxt-link to="/request-demo/" class="btn-light-shade btn-request" data-event="request_demo_3.click">
        Request a Demo
      </nuxt-link>
      <nuxt-link :to="`/checkout/?plan=business&quantity=${businessCounter}`" class="btn-primary btn-start" data-event="start_free_trial_3.click">
        Start a Free Trial
      </nuxt-link>
    </div>
    <div
      class="details" :class="{ 'expanded': details }"
      @click="details = !details"
    >
      <div class="toggle-button">
        {{ details ? 'Hide Details' : 'See Details' }} <IconArrow />
      </div>
      <ul :class="{ 'expanded': details }">
        <li v-for="(data, k) in privileges" :key="k">
          <IconCheck class="icon-check" />
          {{ data }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import IconMinus from '@itbpbg/lms-components/src/assets/svg/checkout-minus-icon.svg?vue-component';
import IconPlus from '@itbpbg/lms-components/src/assets/svg/checkout-plus-icon.svg?vue-component';
import IconArrow from '@itbpbg/lms-components/src/assets/svg/icon-arrow.svg?vue-component';
import IconCheck from '../../assets/svg/check.svg?vue-component';

export default {
  components: {
    IconMinus,
    IconPlus,
    IconArrow,
    IconCheck,
  },
  props: {
    privileges: { type: Array, requred: true, default: () => [] },
  },
  data() {
    return {
      businessCounter: 2,
      details: true,
      show: false,
    };
  },
  methods: {
    counter(type) {
      if (type === 'increase') {
        this.businessCounter = Number(this.businessCounter);
        this.businessCounter += 1;
        if (this.businessCounter >= 30) {
          this.show = true;
          this.businessCounter = 30;
        }
      } else if (type === 'decrease') {
        this.businessCounter = Number(this.businessCounter);
        this.businessCounter -= 1;
        if (this.businessCounter < 30) {
          this.show = false;
        }
      }
    },
    getBusinessPricePerUser() {
      let saving = 0;
      for (let i = 1; i <= this.businessCounter; i += 1) {
        saving += this.getTierPrice(i);
      }

      return saving;
    },
    getTierPrice(q) {
      if (q >= 3 && q <= 5) {
        return 313.2;
      }

      if (q >= 6 && q <= 10) {
        return 278.4;
      }

      if (q >= 11 && q <= 20) {
        return 243.6;
      }

      if (q >= 21 && q <= 30) {
        return 226.2;
      }

      if (q >= 31 && q <= 120) {
        return 99.00;
      }

      return 348;
    },
    setQuantityInState(e) {
      setTimeout(() => {
        let q = +e.target.value;

        if (q > 30) {
          q = 30;
        } else if (q < 2) {
          q = 2;
        }

        // eslint-disable-next-line no-param-reassign
        e.target.value = q;
        this.businessCounter = q;
        if (this.businessCounter < 30) {
          this.showBubble = false;
        }
      }, 500);
    },
    setQuantity(e) {
      const quantity = +e.key;

      if (!quantity && e.key !== 'Backspace' && e.key !== 'Delete' && quantity !== 0 && e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') {
        e.preventDefault();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.plan-card {
  padding: var(--spacing-40) var(--spacing-36);
  background: var(--main-dark-shade-2);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
  border-radius: 10px;

  .h6 {
    color: var(--main-light-shade-4);
  }

  .h2 {
    font-weight: 400;
    font-size: 21px;
    line-height: 140%;
    margin-top: var(--spacing-24);
    margin-bottom: var(--spacing-24);

    .current-price {
      display: inline-block;
      margin-right: -4px;
      font-weight: 500;
      font-size: 64px;
      line-height: 110%;
    }
  }

  .users-holder {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: var(--spacing-24);

    .users {
      display: flex;
      flex-direction: column;
      color: var(--main-light-shade-4);

      .caption {
        font-size: var(--spacing-16);
        line-height: 150%;
      }

      .note {
        font-weight: 500;
        font-size: var(--spacing-12);
        line-height: 120%;
        opacity: 0.7;
      }
    }

    .users-count {
      display: flex;
      align-items: center;
      position: relative;

      .decrease,
      .increase {
        cursor: pointer;
      }

      .decrease {
        &.disabled {
          pointer-events: none;

          path,
          circle {
            stroke: #565E6A;
          }
        }
      }

      .counter {
        padding: var(--spacing-4);
        text-align: center;
        background: #4B5461;
        border: 1px solid #565E6A;
        box-sizing: border-box;
        border-radius: 3px;
        width: 44px;
        height: 28px;
        font-weight: 500;
        line-height: 110%;
        color: var(--main-light);
        margin: 0 6px;
        -moz-appearance: textfield;
      }

      .bubble {
        padding: var(--spacing-18) var(--spacing-16) var(--spacing-24);
        background: var(--main-light);
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
        position: absolute;
        top: 36px;
        right: 0;
        transform: translateX(12%);
        border-radius: 10px;
        // bottom: 36px;
        width: 230px;
        font-size: 14px;
        line-height: 130%;
        text-align: center;
        color: var(--main-dark-shade-0);

        .link-accent {
          cursor: pointer;
        }

        &:before {
          content: '';
          width: 0;
          height: 0;
          position: absolute;
          top: -12px;
          left: 66%;
          margin-left: -7px;
          border-style: solid;
          border-color: var(--main-light) transparent transparent transparent;
          border-width: 6px 7px 6px 7px;
          z-index: 2;
          transform: rotate(180deg);
        }
      }
    }
  }

  .buttons {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-12);

    .btn-request,
    .btn-start {
      padding: var(--spacing-20) 0;
      font-weight: 600;
      line-height: 100%;
    }

    .btn-start {
      order: 1;
    }

    .btn-request {
      order: 2;
    }
  }

  .details {
    display: none;
  }
}

@include bp($bp-mobile) {
  .plan-card {
    width: 100%;
  }
}

@include bp($bp-phone) {
  .plan-card {
    padding: var(--spacing-40) var(--spacing-32);

    .h2 {
      font-size: var(--spacing-18) !important;
      margin: var(--spacing-8) 0 var(--spacing-16) 0;

      .current-price {
        font-size: var(--spacing-40);
      }
    }

    .users-holder {
      .users {
        .caption {
          font-weight: 500;
          font-size: var(--spacing-14);
          line-height: 130%;
        }
      }
    }

    .buttons {
      margin-bottom: var(--spacing-36);
    }

    .details {
      display: flex;
      flex-direction: column;
      font-size: 18px;
      font-weight: 600;
      color: var(--main-dark-shade-4);
      transition: all var(--duration) ease;
      margin: 0;
      cursor: pointer;

      &.expanded {
        div svg {
          transform: rotate(180deg);
        }
      }

      .toggle-button {
        align-self: flex-start;
        line-height: 100%;
        letter-spacing: 0.02em;

        svg {
          margin-left: var(--spacing-6);

          path[stroke] {
            stroke: var(--main-dark-shade-4);
          }
        }
      }

      ul {
        display: none;
        list-style: none;
        padding: 0;
        margin: 0;

        &.expanded {
          display: block;
          max-height: 1000px;
          margin-top: var(--spacing-24);
        }

        li {
          font-weight: 400;
          font-size: var(--spacing-16);
          line-height: 150%;
          color: var(--main-light);
          margin-bottom: 10px;

          &:last-of-type {
            margin-bottom: 0;
          }

          .icon-check {
            margin-right: var(--spacing-14);
          }
        }
      }
    }
  }
}
</style>
